import {
  useEffect,
  useState
} from 'react'
import {
  Box,
  Skeleton
} from '@chakra-ui/react'
import { setOpenBlogLink } from 'store'
import {
  convertFromRaw,
  EditorState
} from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'

const LazyImageBlock = ({ block, contentState }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const { src, alignment } = contentState.getEntity(block.getEntityAt(0)).getData()
  let imgAlignment = 'center'

  if (alignment === 'left') {
    imgAlignment = 'flex-start'
  }

  if (alignment === 'right') {
    imgAlignment = 'flex-end'
  }

  useEffect(() => {
    if (src.includes(';base64,')) {
      setImageLoaded(true)
    } else {
      setImageLoaded(false)
    }
  }, [src])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: imgAlignment
      }}
    >
      <Skeleton
        isLoaded={imageLoaded}
        fadeDuration={1}
      >
        <img
          src={src}
          alt="content"
          onLoad={() => setImageLoaded(true)}
          style={{
            width: imageLoaded ? 'auto' : '70svw',
            height: imageLoaded ? 'auto' : '120px'
          }}
        />
      </Skeleton>
    </div>
  )
}

const EmbedBlock = ({
  block,
  contentState,
  blockProps
}) => {
  const { src } = contentState.getEntity(block.getEntityAt(0)).getData()
  const { dispatch } = blockProps

  return (
    <Box
      width="100%"
      maxWidth="560px"
      margin="8px auto"
    >
      <Box
        position="relative"
        paddingTop="56.25%"
        borderRadius="5px"
        overflow="hidden"
      >
        <iframe
          src={src}
          title="embed"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
            borderRadius: '5px'
          }}
        />

        <Box
          position="absolute"
          bottom="0"
          right="0"
          zIndex="40"
          background="transparent"
          width="100%"
          height="100%"
          padding="0"
          cursor="pointer"
          onClick={() => dispatch(setOpenBlogLink(src + '?autoplay=1'))}
          _hover={false}
          _active={false}
          _focusVisible={false}
          _focus={false}
        />
      </Box>
    </Box>
  )
}

export const TextEditorReader = ({
  dispatch,
  item,
  widen,
  setCloseAllDrawers
}) => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty())
  const [firstBlockText, setFirstBlockText] = useState('')

  const blockRendererFn = (block) => {
    if (block.getType() === 'atomic') {
      const contentState = editorState.getCurrentContent()
      const entityKey = block.getEntityAt(0)

      if (!entityKey) return null

      const entityType = contentState.getEntity(entityKey).getType()

      if (entityType === 'EMBED') {
        return {
          component: EmbedBlock,
          editable: false,
          props: { dispatch }
        }
      }

      return { component: LazyImageBlock, editable: false }
    }

    return null
  }

  const customLinkClick = () => {
    const editorLinks = document.querySelectorAll('.public-DraftStyleDefault-block a')

    if (editorLinks) {
      editorLinks.forEach((link) => {
        const href = link.getAttribute('href')

        if (href.startsWith(window.location.origin + '/?id=')) {
          const hrefId = href.split('/?id=')[1]

          link.addEventListener('click', (e) => {
            e.stopPropagation()
            e.preventDefault()

            if ((window.location.href).split('/?id=')[1] !== hrefId) {
              dispatch(setCloseAllDrawers(true))
              const customPopupOverlay = document.querySelector('#custom-popup-overlay')
              if (customPopupOverlay) {
                customPopupOverlay.click()
              }

              setTimeout(() => {
                dispatch(setCloseAllDrawers(false))

                const event = new CustomEvent('custom-chat-show_on_map', {
                  detail: {
                    jid: hrefId + '-'
                  }
                })
                window.dispatchEvent(event)
              }, 850)
            }
          })
        } else {
          link.setAttribute('target', '_blank')
          link.setAttribute('rel', 'noopener noreferrer')
        }
      })
    }
  }

  useEffect(() => {
    if (item.body) {
      const raw = { ...item.body }
      const firstBlock = raw.blocks[0]
      const lastBlock = raw.blocks[raw.blocks.length - 1]
      setFirstBlockText(firstBlock.text)

      if (
        firstBlock
        && firstBlock.type === 'unstyled'
        && firstBlock.text.trim() === ''
      ) {
        raw.blocks = raw.blocks.slice(1)
      }

      if (
        lastBlock
        && lastBlock.type === 'unstyled'
        && lastBlock.text.trim() === ''
      ) {
        raw.blocks = raw.blocks.slice(0, -1)
      }

      const contentState = convertFromRaw(raw)
      setEditorState(EditorState.createWithContent(contentState))

      setTimeout(() => customLinkClick(), 500)
    }
  }, [item.body])

  return (
    <Box>
      <Editor
        editorState={editorState}
        blockRendererFn={blockRendererFn}
        readOnly
        toolbarHidden
        editorStyle={{
          fontSize: widen ? '22px' : '16px',
          transition: 'font-size 0.8s',
          paddingTop: firstBlockText === '' ? '30px' : 0
        }}
      />
    </Box>
  )
}
